var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignIndividuallyEditLep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22667_116942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9974 6.66671L9.33075 4.00004M1.66406 14.3334L3.92031 14.0827C4.19597 14.0521 4.3338 14.0367 4.46263 13.995C4.57692 13.958 4.68569 13.9058 4.78599 13.8396C4.89903 13.7651 4.99709 13.667 5.19321 13.4709L13.9974 4.66671C14.7338 3.93033 14.7338 2.73642 13.9974 2.00004C13.261 1.26366 12.0671 1.26366 11.3307 2.00004L2.52655 10.8042C2.33043 11.0003 2.23237 11.0984 2.15782 11.2114C2.09168 11.3117 2.03941 11.4205 2.0024 11.5348C1.9607 11.6636 1.94539 11.8015 1.91476 12.0771L1.66406 14.3334Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22667_116942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIndividuallyEditLep);
export default __webpack_public_path__ + "static/media/assign-individually-edit-lep.2ed84198d38254c79cadf58eb9975341.svg";
export { ForwardRef as ReactComponent };